import { render, staticRenderFns } from "./alloc_pay.vue?vue&type=template&id=6bd2d88e&scoped=true&"
import script from "./alloc_pay.vue?vue&type=script&lang=js&"
export * from "./alloc_pay.vue?vue&type=script&lang=js&"
import style0 from "./alloc_pay.vue?vue&type=style&index=0&id=6bd2d88e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd2d88e",
  null
  
)

export default component.exports